<template>
  <Popover ref="itemPopover" :showHeader="true" :headerTitle="`${itemTitle}`" sizeClass="popover-xxlarge" :scrollable="true">
    <div class="po-summary-popover">
      <LoadingPanel :loading="loading" :loadingError="loadingError" />
      <div v-if="purchaseOrder && !loading">
        <ContentTitle>Purchase Order Items</ContentTitle>
        <OrderItemPreviewList :itemList="purchaseOrder.purchaseOrderItems" />
      </div>
    </div>
  </Popover>
</template>

<style scoped>
.po-summary-popover {
  padding: 10px;
  font-size: 0.8rem;
  line-height: 1.1rem;
  min-width: 400px;
  min-height: 200px;
}
</style>

<script>
import _ from 'lodash'
import FormMixin from '@/mixins/form'
import Popover from '@/components/popover.vue'

import OrderItemMixin from '@/modules/orders/mixins/orderItemMixin'
import OrderItemPreviewList from '@/modules/orders/components/orderItemPreviewList'

export default {
  name: 'PurchaseOrderSummaryPopover',
  mixins: [FormMixin, OrderItemMixin],
  components: {
    Popover,
    OrderItemPreviewList
  },
  computed: {
    itemTitle() {
      if(!this.purchaseOrder)
        return ''
      return `Purchase Order ${this.purchaseOrder.sequenceNumber || ''}`
    }
  },
  data() {
    return {      
      loading: false,
      loadingError: '',
      purchaseOrderId: null,
      purchaseOrder: null,
      displayItemList: []
    }
  },
  created() {

  },
  methods: {
    displayFromElement(element, purchaseOrderId) {
      this.purchaseOrderId = purchaseOrderId
      this.requestData()

      this.$refs.itemPopover.displayFromElement(element)
    },
    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.purchasingService.getPurchaseOrder(this.purchaseOrderId)
      .then(response => {
        this.purchaseOrder = response.data

        // Copy the order item list & modify for display/editing
        this.purchaseOrder.purchaseOrderItems = this.buildOrderItemList(this.purchaseOrder.purchaseOrderItems)

      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })      
    }
  }
}
</script>